<template>

    <div>
        <el-dialog title="请输入手机验证码" :visible.sync="dialogVisible" width="520px" center custom-class="codeDialog" :close-on-click-modal="false"
            style="top:20vh">
            <div class="code-row">
                <span class="code-label">验证码</span>
                <div style="position: relative;width: 100%;">
                    <el-input v-model="formInline.smsCode" placeholder="请输入验证码" class="code-input"></el-input>
                    <el-button class="code-btn" @click="reGetCode" type="text" :disabled="timeout != 120">
                        {{ timeout != 120 ? timeout + '秒后重试' : '重新获取验证码' }}
                    </el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="getData"
                    :disabled="!formInline.smsCode">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { authByCodeFromSecond,reSendCodeFromSecond,authByCode,reSendCode} from "@/api/openNew.js"

export default {
    data() {
        return {
            dialogVisible: false,
            formInline: {
                smsCode: '',
            },
            timeout: 120,
            taskId:null,
            taxNo:null,
            programId:'',
            loginType:1,

        };
    },
    methods: {

        async getData(){
        this.loading = this.$loading({
                lock: true,
                text:'验证中..',
                spinner: "el-icon-loading",
                background: "rgba(255, 255, 255, 0.8)",
                customClass:'loadingClass'
            });
            const params={
                taskId:this.taskId,
                smsCode:this.formInline.smsCode,
                taxNo:this.taxNo
            }
            let res
            if(this.$route.name =='oemGuardV4'||this.$route.name =='oemGuardV5'){
                res=await authByCode(params,this.loginType)
            }else{
                res=await authByCodeFromSecond(params,this.loginType)
            }
            this.loading.close();

            if(res.code == 200 ){
                this.dialogVisible = false
                this.$emit('success')

            }else if(res.code == 5001 || res.code == -1) {
                    // this.$message.error(res.message)
                    this.$emit('messagePasswords',res.message)


                }
        },
        async reGetCode(){
            const params={
                taskId:this.taskId,
                programId:this.programId
            }
            let res
            if(this.$route.name =='oemGuardV4'||this.$route.name =='oemGuardV5'){
                res=await reSendCode(params,this.loginType)
            }else{
                res=await reSendCodeFromSecond(params,this.loginType)
            }
            if(res.code == 200 ){
                this.taskId=res.data.taskId
                if(this.timer){
                    clearInterval(this.timer)
                    this.timer = null
                }
                this.startTimeOut(119)
            }
        },
        startTimeOut(remainingSeconds){
            this.timeout = remainingSeconds
            this.timer = setInterval(()=>{
                this.timeout--
                if(this.timeout == 0) {
                    clearInterval(this.timer)
                    this.timer = null
                    this.timeout=120
                }
            },1000)
        },

        openDialog(e,taxNos,pId,lt) {
            this.taskId = e
            this.taxNo = taxNos
            this.programId = pId||''
            this.loginType=lt || 1
            this.formInline.smsCode = ''

            if(this.timer){
                // 上次倒计时还在进行中，清掉旧定时器，用当前 timeout 值继续倒计时
                clearInterval(this.timer)
                this.timer = null
                this.startTimeOut(this.timeout)
                this.dialogVisible = true;
                return;
            }
            // 首次打开：立即将 timeout 置为 119，消除按钮短暂可点的窗口期
            this.startTimeOut(119)

            this.dialogVisible = true;
        },
    }
};
</script>
<style lang="stylus">
.loadingClass{
    z-index: 9999!important;
}
.codeDialog {
    border-radius: 8px;
    background-color: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}

.codeDialog.el-dialog .el-dialog__header {
    font-family: PingFang SC;
    color: #1D2129;
    font-weight: 600;
    font-size: 16px;
    padding: 24px 24px 14px 24px;
}

.codeDialog .el-dialog__body {
    padding: 10px 24px 0 24px;
}

.codeDialog.el-dialog--center .el-dialog__footer {
    text-align: right;
    padding: 16px 24px 24px 24px;
}

/* 验证码行布局 */
.code-row {
    display: flex;
    align-items: center;
    margin-bottom 8px
}

.code-label {
    flex-shrink: 0;
    font-size: 14px;
    color: #1D2129;
    font-family: PingFang SC;
    margin-right: 12px;
    white-space: nowrap;
}

.code-row .code-input {
    flex: 1;
}

.code-row .code-input .el-input__inner {
    height: 32px;
    line-height: 32px;
}

.code-row .code-btn {
    flex-shrink: 0;
    position: absolute;
    right: 0;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    margin-left: 12px;
    color: #165DFF;
    font-size: 14px;
    font-family: PingFang SC;
    white-space: nowrap;
}

.code-row .code-btn:disabled {
    color: #A4A6A9;
}

/* footer 确定按钮 */
.dialog-footer .el-button {
    height: 32px;
    min-width: 80px;
    line-height: 32px;
    font-size: 14px;
    padding: 0 20px;
    text-align: center;
    font-family: PingFang SC;
    font-weight: 400;
}

.dialog-footer .el-button.el-button--primary:not([disabled]) {
    background-color: #165DFF;
    color: #FFFFFF;
    border: 0;
}

.dialog-footer .el-button.el-button--primary:disabled {
    background-color: #F4F6F8;
    color: #A4A6A9;
    border: 1px solid #DFDFE0;
}

.codeDialog{
    .el-dialog__header{
        border-bottom 0 none
        padding-bottom 14px
    }
    .el-dialog__footer{
        border-top 0 none
    }
}
</style>
